import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import { chartingToolColors } from 'utils/colors';
import { displayLineChartDots } from 'utils/constants';
import Decimal from 'decimal.js';

class LineChart extends Component {
  createChartConfig = ({ xAxis, yAxis, original }) => ({
    legend: {
      display: false,
    },
    elements: {
      line: {
        tension: 0.9,
      },
    },
    tooltips: {
      enabled: true,
      mode: 'nearest',
      callbacks: {
        title() {
          return '';
        },
        beforeLabel(item) {
          if (item.datasetIndex === 1) {
            const actualItem = original[item.index];
            return `Ticker: ${actualItem.ticker}`;
          }
          return 'Target Portfolio';
        },
        label(item) {
          const return2Decimals = new Decimal(item.yLabel).toFixed(2);
          const risk2Decimals = new Decimal(item.xLabel).toFixed(2);
          return `Return: ${return2Decimals}% | Risk: ${risk2Decimals}%`;
        },
      },
    },
    hover: {
      mode: 'index',
      intersect: false,
    },
    scales: {
      xAxes: [
        {
          type: 'linear',
          ticks: {
            callback: (value) =>
              String(new Decimal(value).toDecimalPlaces(1) * 1),
          },
          gridLines: {
            borderDash: [2, 2],
          },
          scaleLabel: {
            display: true,
            labelString: `${xAxis} (%)`,
            fontColor: '#000000',
            fontSize: 13,
            fontStyle: 'bold',
            content: 'abcd',
          },
        },
      ],
      yAxes: [
        {
          type: 'linear',
          ticks: {
            callback: (value) =>
              String(new Decimal(value).toDecimalPlaces(1) * 1),
          },
          gridLines: {
            borderDash: [2, 2],
          },
          scaleLabel: {
            display: true,
            labelString: `${yAxis} (%)`,
            fontColor: '#000000',
            fontSize: 13,
            fontStyle: 'bold',
          },
        },
      ],
    },
  });

  render() {
    const { data } = this.props;
    const { efficient, original } = data;
    const graphData = {
      datasets: [
        {
          lable: 'efficient frontier curve',
          data: efficient,
          fill: false,
          borderColor: chartingToolColors.darkBlue2,
          backgroundColor: chartingToolColors.darkBlue2,
          lineTension: 0.4,
          pointRadius: efficient.length > displayLineChartDots ? 0 : 2,
          pointHitRadius: 2,
        },
        {
          label: 'original holdings',
          data: original,
          fill: false,
          borderColor: chartingToolColors.orange,
          backgroundColor: chartingToolColors.orange,
          lineTension: 0,
          pointRadius: 4,
          showLine: false,
          pointHitRadius: 2,
        },
      ],
    };

    return <Line data={graphData} options={this.createChartConfig(data)} />;
  }
}

LineChart.propTypes = {
  data: PropTypes.object,
};

LineChart.defaultProps = {
  data: {},
};

export default LineChart;
